import { removeCookie } from "@workspace/cookies/browser";
import { useCallback, useEffect } from "react";
import enableMarketingTag from "@/actions/enableMarketingTag";
import useAcqOfferCookies from "@/client/components/MarketingTagsClient/useMarketingTags/useAcqOfferTags/useAcqOfferCookies";
import isSsr from "@/shared/utils/isSsr";

const useAcqOfferTags = (isLoggedIn: boolean, site: Site) => {
  const marketingCookies = useAcqOfferCookies(site);

  const setAcqOfferTags = useCallback(async () => {
    marketingCookies.forEach(async (tag) => {
      const { isTagEnabled } = await enableMarketingTag(tag);
      if (isTagEnabled) {
        removeCookie(tag);
      }
    });
  }, [marketingCookies]);

  useEffect(() => {
    if (!isSsr() && isLoggedIn && marketingCookies.length) {
      setAcqOfferTags();
    }
  }, [isLoggedIn, marketingCookies, setAcqOfferTags]);
};

export default useAcqOfferTags;
